import React, { useEffect } from "react";
import FourProductCardBox from "../Components/HomeCards/FourProductCardBox"; // ← new component
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";

import HeroImg from "../Assets/hot_bakes.png";
import HotBakeImg1 from "../Assets/1_ham_and_cheese_hot_bake.png";
import HotBakeImg2 from "../Assets/2_chicken_hot_bake.png";
import HotBakeImg3 from "../Assets/3_vegan_ham_and_cheese_bake.png";
import HotBakeImg4 from "../Assets/4_vegan_chicken_hot_bake.png";

import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function HotBakes() {
  // Meta Pixel ViewContent event on mount
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "ViewContent", {
        content_name: "Hot Bakes | Đông Hưng Viên Bakery",
      });
    }
  }, []);

  useMetaTracking("ViewContent", {
    content_name: "Hot Bake",
    content_category: "New Menu",
    content_ids: ["hot_bake"],
    content_type: "pastries",
  });

  return (
    <>
      <Helmet>
        <title>Hot Bakes | Đông Hưng Viên Bakery</title>
      </Helmet>

      <Box sx={{ pt: 10, background: "#0f0f0f" }}>
        <FourProductCardBox
          cardImg={HeroImg}
          titleHead="HOT BAKES"
          detailHead="Available in-store now!"
          detailBody={
            <>
              Delicious handheld pastries made from flaky puff‑pastry dough (the
              same dough as our pâté chaud) and generously filled with savory
              ingredients. <br />
              <br />
              Perfectly baked to a crisp and available in classic or vegan
              flavors—great for breakfast on‑the‑go, quick lunches, or anytime
              snacks that satisfy your cravings!
            </>
          }
          items={[
            {
              img: HotBakeImg1,
              title: "HAM & CHEESE",
              link: "/ham-and-cheese-hot-bake",
            },
            {
              img: HotBakeImg2,
              title: "CHICKEN",
              link: "/chicken-hot-bake",
            },
            {
              img: HotBakeImg3,
              title: "VEGAN HAM & CHEESE",
              link: "/vegan-ham-and-cheese-hot-bake",
            },
            {
              img: HotBakeImg4,
              title: "VEGAN CHICKEN",
              link: "/vegan-chicken-hot-bake",
            },
          ]}
        />

        <Footer />
      </Box>
    </>
  );
}

export default HotBakes;